import axios from "axios";

export const CreateGoatList = async (data: any, headers: any) => {
  const res = await axios.post("/api/add-goat-list", data, headers);
  return res.data;
};

// Admin Debates API functions
export const CreateDebateAdmin = async (headers: any, data: any) => {
  const res = await axios.post("/api/admin/debates", data, headers);
  return res.data;
};
